module.exports = __webpack_public_path__ + "img/level3addon_running_mask.989b4a30.png";